export const policyDataPageType = {
    gcli_prin: 'GCLIP_PRIN',
    gcli_out: 'GCLIP_OUT',
    gpa_gaddp: 'GPA_GADDP',
} as const;

export const policyContractType = {
    outstanding: 'outstanding',
    principal: 'principal',
    gpa: 'gpa',
} as const;